import { IExpression } from '../IExpression';
import { collectExpressionReferences } from '../references/collectExpressionReferences';
import { materializeReferences } from './materializeReferencePath';

/**
 * Data un espressione, ritorna i path e le reference associate.
 */
export function getMaterializedExpressionReferences(input: {
  name: string;
  expression:
    | Array<IExpression | null | undefined>
    | IExpression
    | null
    | undefined;
}) {
  const { name, expression } = input;
  if (!expression) {
    return {
      references: [],
      paths: [],
    };
  }

  const references = Array.isArray(expression)
    ? expression.flatMap(e => collectExpressionReferences(e))
    : collectExpressionReferences(expression);

  const materializedRefs = materializeReferences(references, name);
  return {
    references: materializedRefs,
    paths: materializedRefs.map(r => r.absolutePath),
  };
}
